import { ResourceProps } from 'react-admin';

// Recurso INTANGIBLE: sin list/show/edit no genera rutas, pero queda registrado
// para que el data provider lo resuelva. Es lo que necesitan las lecturas por
// referencia de la ficha del inversor (`useGetManyReference('investments', …)`)
// y el cajón de edición. El libro se administra desde la ficha, que es donde
// están el contexto y las validaciones; no hay pantalla suelta de inversiones.
let resourceProps: ResourceProps = {
  name: 'investments',
};

export default resourceProps;
